import React from 'react'
import SevenStar from './7star'
import SevenStarJasem from './7starjasem'
import Syzygy from './syzygy'

const BillingDetailsTable = ({ company = '', data = {},allowances = [] }) => {
    return <SevenStar data = {data}  allowances = {allowances}/>
    /*
    switch (company) {
        case '7star':
            return <SevenStar company={company} data={data} />
        case '7starjasem':
            return <SevenStarJasem company={company} data={data} />
        case 'syzygy':
            return <Syzygy company={company} data={data} />
        default:
            return null
    }
            */
}

export default BillingDetailsTable